<template>
  <div class="sorting-main">
    <v-menu offset-y :close-on-content-click="false">
      <template v-slot:activator="{ on, attrs }">
        <span>
          {{ item.name }}
          <v-icon
            v-bind="attrs"
            v-on="on"
            class="icon-filter"
            role="button"
            tabindex="0"
            :aria-label="$t('Сортировка') + ': ' + item.name"
            :class="{ active: (item.key && item.key === currentOrderKey) || filter !== null || (item.keys && item.keys.includes(currentOrderKey)) }"
            @keydown.enter.prevent="on.click"
            @keydown.space.prevent="on.click"
          >filter_list</v-icon>
        </span>
      </template>
      <v-card
        class="sorting"
        max-width="260"
      >
        <template v-if="item.key">
          <div class="sorting__top">
            <h6 class="mt-0">
              {{ item.name }}
            </h6>
            <p
              v-for="(order, i) in orderItems"
              :key="i"
              :class="(order.value === orderDir && item.key === currentOrderKey) ? 'active' : ''"
            >
              <a href="#" @click.prevent="orderHandler(order.value, item.key)">
                <span v-html="order.title"></span>
              </a>
            </p>
            <p><a href="#" @click.prevent="cancelSorting()">{{ $t('Отменить сортировку') }}</a></p>
          </div>
        </template>
        <template v-if="item.children">
          <div class="sorting__top" v-for="(child, ind) in item.children" :key="ind">
            <h6 class="mt-0">
              {{ child.name }}
            </h6>
            <p
              v-for="(order, i) in orderItems"
              :key="i"
              :class="(order.value === orderDir && child.key === currentOrderKey) ? 'active' : ''"
            >
              <a href="#" @click.prevent="orderHandler(order.value, child.key)">
                <span v-html="order.title"></span>
              </a>
            </p>
            <p v-if="ind === Object.keys(item.children).length - 1"><a href="#" @click.prevent="cancelSorting()">{{ $t('Отменить сортировку') }}</a></p>
          </div>
        </template>
        <div v-if="filterable" class="sorting__bottom mb-2">
          <v-row no-gutters class="my-3">
            <v-col>
              <strong>{{ $t('Фильтр') }}</strong>
            </v-col>
            <v-col class="text-right">
              <a href="#" @click.prevent="clearFilter(item.key)">{{ $t('Сбросить фильтр') }}</a>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <div class="select-def">
              <v-select
                :items="item.filterItems"
                item-value="id"
                item-text="transName"
                v-model="filter"
                :aria-label="$t('Фильтр') + ': ' + item.name"
                required
                outlined
                dense
                clearable
                hide-details
                @change="filterHandler($event, item.key)"
              />
            </div>
          </v-row>
        </div>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    item: { type: Object },
    currentOrderKey: { type: String },
    filterable: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    filter: null,
    orderDir: null
  }),
  computed: {
    orderItems() {
      const fields = [
        {
          title: 'Сортировать A <v-icon class="v-icon material-icons">arrow_right_alt</v-icon> Я',
          value: 'asc'
        },
        {
          title: 'Сортировать Я <v-icon class="v-icon material-icons">arrow_right_alt</v-icon> А',
          value: 'desc'
        }
      ]
      return fields
    }
  },
  methods: {
    orderHandler(orderDir, itemKey) {
      this.orderDir = orderDir
      const sort = { key: itemKey, value: this.orderDir }
      this.$emit('order', sort)
    },
    filterHandler(value, itemKey) {
      const filter = { name: itemKey, value: value }
      this.$emit('filter', filter)
    },
    clearFilter(itemKey) {
      if (!!this.filter) {
        this.filter = null
        const filterForm = { name: itemKey, value: this.filter }
        this.$emit('filter', filterForm)
      }
    },
    cancelSorting() {
      this.$emit('cancelSorting')
    }
  }
}
</script>
